import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const MessagePage = () => {

    const navigate = useNavigate()

    useEffect(() => {
        localStorage.setItem("currentIndex", 0)
        localStorage.setItem("currentKeyIndex", 0)
        localStorage.setItem("currentNext30Index", 0)
        localStorage.setItem("currentPlanIndex", 0)
        localStorage.setItem("prevMessagePage", 'false')
    }, [])

    const navigateToCourses = () => {
      navigate("/daily-work")
      localStorage.removeItem("userId")
    }

  return (
    <main className="auth">
      <div className="auth-layout">
        <div className="auth-view">
          <div className="message-page-auth-view__container">
            <div className="message-page-view">
              <div className="message-page-heading">AMAZING!!</div>
              <div>
                <p style={{color: "#fff"}}>You have yourself up for the successful next quarter!</p>
                <p style={{color: "#fff"}}>Is there any aspect you wish to review or change before we continue?</p>
              </div>
              <form className="driver-form">
                <div
                  style={{
                    display: "flex",
                    // gap: "1rem",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <button type="button" className="message-page-btn" onClick={() => {navigate('/onboarding-driver/credo'); localStorage.setItem('prevMessagePage', true)}}>
                    <span className="driver-button__label">CREDO</span>
                  </button>

                  <button type="button" className="message-page-btn" onClick={() => {navigate('/onboarding-driver/ignition'); localStorage.setItem('prevMessagePage', true)}}>
                    <span className="driver-button__label">IGNITION STATEMENT</span>
                  </button>
                  <button type="button" className="message-page-btn" onClick={() => {navigate('/onboarding-driver/gap-map'); localStorage.setItem('prevMessagePage', true)}}>
                    <span className="driver-button__label">GAP MAP</span>
                  </button>
                  <button type="button" className="message-page-btn" onClick={() => {navigate('/plan-for-success/next90'); localStorage.setItem('prevMessagePage', true)}}>
                    <span className="driver-button__label">Next 90</span>
                  </button>
                  <button type="button" className="message-page-btn" onClick={() => {navigate('/plan-for-success/next30'); localStorage.setItem('prevMessagePage', true)}}>
                    <span className="driver-button__label">Next 30</span>
                  </button>
                  <button type="button" className="message-page-btn" onClick={() => {navigate('/plan-for-success/key4'); localStorage.setItem('prevMessagePage', true)}}>
                    <span className="driver-button__label">KEY 4</span>
                  </button>

                  <button type="button" className="message-page-next-btn" onClick={navigateToCourses}>
                    <span className="message-page-driver-button__label">I'm ready to crush the next quarter</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default MessagePage;
